module.exports = __webpack_public_path__ + "static/assets/4d17cd98c3fa3b9766eedca38a8b7216.gif";